import { useFormik } from 'formik'
import { FC } from 'react'
import {
  ButtonType,
  showAlert,
  showConfirmAlert,
  showError,
} from '../../../../../../../_metronic/helpers'
import {
  Button,
  FormInput,
  FormTextArea,
  LoadingIndicator,
  useModal,
} from '../../../../../../components'
import { notaSchema } from './validation/notaSchema'
import { AtualizaValorAdicionalDto } from '../../../faturas-list/core/_models'
import { autorizaNotaComValorAdicional, cancelarNota, updateValorNota } from '../../core/_requests'

interface IProps {
  action: 'autorizar' | 'cancelar' | 'adicional'
  idNota: number
}

export const NotaModal: FC<IProps> = ({ action, idNota }) => {
  const { closeModal } = useModal()

  const formik = useFormik({
    initialValues: {
      observacao: '',
      valor: undefined,
      action,
    },
    validationSchema: notaSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        const isConfirmed = await showConfirmAlert({ confirmButtonText: 'Sim' })
        if (!isConfirmed) return

        if (action === 'cancelar') {
          await cancelarNota(idNota, values.observacao)
          showAlert({
            title: 'Sucesso',
            text: 'Nota cancelada com sucesso!',
            icon: 'success',
          })
        } else {
          const data: AtualizaValorAdicionalDto = {
            observacao: values.observacao.trim() || undefined,
            valor: Number(values.valor),
          }

          if (action === 'adicional') await updateValorNota(idNota, data)
          if (action === 'autorizar') await autorizaNotaComValorAdicional(idNota, data)

          showAlert({
            title: 'Sucesso',
            text:
              action === 'adicional'
                ? 'Valor adicional atualizado com sucesso!'
                : 'Nota com valor adicional autorizada com sucesso!',
            icon: 'success',
          })
        }

        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <FormTextArea
        name='observacao'
        formik={formik}
        label={action !== 'cancelar' ? 'Observação' : 'Motivo'}
        placeholder={action !== 'cancelar' ? 'Digite uma observação' : 'Digite o motivo'}
        isDisabled={formik.isSubmitting}
        className='mb-3'
        isRequired={action === 'cancelar'}
      />
      {action !== 'cancelar' && (
        <FormInput
          formik={formik}
          name='valor'
          type='number'
          label='Valor (R$)'
          placeholder='Digite o valor (R$)'
          isRequired
        />
      )}

      <div className='d-flex justify-content-center mt-10'>
        <Button className='btn-secondary me-3' disabled={formik.isSubmitting} onClick={closeModal}>
          Cancelar
        </Button>
        <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
          {formik.isSubmitting ? <LoadingIndicator /> : 'Salvar'}
        </Button>
      </div>
    </form>
  )
}
